import {QueryKey, useMutation, useQuery, UseQueryOptions} from '@tanstack/react-query'
import {
    fetchVessels,
    lookupOtsmOnlyVessel,
    OtsmVesselRequest,
    validateOtsmOnlyVessels,
} from '../api/vessels'
import {AxiosRequestConfig} from 'axios'

const queryKeys = {
    vessels: 'vessels',
}

// Using this causes 1 extra API call as we currently
// have redux thunk that also fetches vessels. Refactoring all
// components that depends on the redux state is a whole lot of
// work by itself.
export function useVesselsQuery(
    options?: UseQueryOptions<unknown, unknown, Awaited<ReturnType<typeof fetchVessels>>, QueryKey>,
) {
    return useQuery({
        retry: false,
        queryKey: [queryKeys.vessels],
        queryFn: async () => await fetchVessels(),
        ...options,
    })
}

export function useValidateOtsmVesselMutation() {
    return useMutation({
        mutationFn: async (data: {
            vesselsInfo: OtsmVesselRequest[]
            config?: AxiosRequestConfig
        }) => {
            return await validateOtsmOnlyVessels(data.vesselsInfo, data.config)
        },
    })
}

export function useLookupOtsmVesselMutation() {
    return useMutation({
        mutationFn: async (data: {imos: string[]; config?: AxiosRequestConfig}) => {
            return await lookupOtsmOnlyVessel(data.imos, data.config)
        },
    })
}
